import React, { useState, useEffect } from 'react';
import { CSVImport } from '@src/component/rule-engine/import/CSVImportFIle'
import { uploadAddOnCsv } from '@src/store/slices/common';
import { toast } from 'react-toastify';
import secureStorage from "@src/config/encrypt";
import FullPageLoader from '@src/common/FullPageLoader';
import * as HELPER from "@src/config/helper";
import { APP_AGENCY, ROLE_FEATURES, STATUS_SUCCESS } from "@src/config/constant";
import ReactSelect from '@common/ReactSelect';
import { getMasterConfig } from '../../../store/slices/common';
import { useDispatch, useSelector } from 'react-redux'
// import { bulkUploadLeadLogs } from '@store/slices/insurance';
// import { getBulkUploadLeadLogs, downloadBulkUploadLeadLogs } from '../../../store/slices/insurance';
import { getBulkUploadLeadLogs, downloadBulkUploadLeadLogs, getSampleFile } from '@src/store/slices/insurance';
import { downloadBulkUploadLogs, getBulkUploadAgencyLogs, uploadCsv } from '@src/store/slices/agency';
import { useLanguage } from '@src/context/LanguageContext';


interface MRPBCAMFModalProps {
    setUpdateModal: any;
    type: any;
    closeBulkUploadModal: any;
}


const BulkImportModal: React.FC<MRPBCAMFModalProps> = ({ setUpdateModal, type, closeBulkUploadModal }) => {
    const [csvValue, setCsvValue] = useState<any>(null);
    let [loading, setLoading] = useState<boolean>(false)
    let [emptyErr, setEmptyErr] = useState<boolean>(false)

    const [csvReset, setCsvReset] = useState(0);

    const [BlankFlage, setBlankFlage] = useState(0);
    const [urlLink, setUrlLink] = useState('');

    const dispatch: any = useDispatch()
    const commonState = useSelector((state: any) => state.common)
    let [methodList, setMethodList] = useState<[]>([])
    const [selectedFilters, setSelectedFilters] = useState<any>({application_type: APP_AGENCY});
    const errField = ({
        appType: ""
    });

    const [bulkLog, setBulkLog] = useState([]);

    const insuranceState = useSelector((state: any) => state.insurance)

    const {translations} = useLanguage();
    

    const validForm = () => {
        let formIsValid = true;
        // App Type required only for base issue rate
        // if (type === 'Base Issue Rate') {
        //     if (Object.keys(selectedFilters).length === 0) {

        //         formIsValid = false;
        //         setErrField((prevState: any) => ({
        //             ...prevState,
        //             appType: "Application Type is required",
        //         }));
        //     }
        // }

        if (!csvValue) {

            formIsValid = false;
            setEmptyErr(true);
        }
        return formIsValid;
    };


    const handleImport = async () => {
        if (!validForm()) return;

        const result = secureStorage.getItem("authUserInfo");
        const userId = result?.user_data?.id;

        setLoading(true);

        const formData = new FormData();
        formData.append("type", type);
        formData.append("images", csvValue);
        formData.append("user_id", userId);
        formData.append("application_type", selectedFilters.application_type);

        // Decide which upload function and which log fetch function to use
        const uploadFn = type === "uploadID" ? uploadCsv : uploadAddOnCsv;
        const logFn = type === "uploadID" ? getBulkUploadAgencyLogs : getBulkUploadLeadLogs;

        try {
            const res: any = await uploadFn(formData);
            setLoading(false);
            closeBulkUploadModal();

            if (res?.status === STATUS_SUCCESS) {
                toast.success(res.message);
                setUpdateModal(false);
                setCsvValue("");
                setBlankFlage((prev) => prev + 1);
                setLoading(true);
                const data: any = await logFn();
                setBulkLog(data?.data);
                setLoading(false);
            } else {
                resetCsvState();
            }
        } catch (err) {
            setLoading(false);
            resetCsvState();
        } finally {
            setCsvReset((prev) => prev + 1);
        }
    };

    const resetCsvState = () => {
        setCsvValue("");
        setBlankFlage((prev) => prev + 1);
    };


    useEffect(() => {

        if(!insuranceState?.sampleCsv?.length) {
            dispatch(getSampleFile()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    
                }
            }).catch((err: Error) => {
            })
        }

        setLoading(true)
        if (type === 'uploadID') {
            getBulkUploadAgencyLogs().then((data: any) => {
                setBulkLog(data?.data)
                setLoading(false);
            })
        } else {
            getBulkUploadLeadLogs().then((data: any) => {
                setBulkLog(data?.data)
                setLoading(false)

            });
        }
       

        // eslint-disable-next-line
    }, [type]);


    useEffect(() => {
        if (commonState && commonState.common && Object.keys(commonState.common).length) {
            let data = commonState.common
            let { apptype } = data
            setMethodList(apptype)

        }
        else {
            //api call to fetch static dropdowns
            dispatch(getMasterConfig()).then((res: any) => {
                if (res && res.status === STATUS_SUCCESS) {
                    let data: any = res.data || {}
                    let { apptype } = data
                    setMethodList(apptype)

                }
            }).catch((err: Error) => {
            })
        }
    }, [dispatch, commonState])


    // Handle changes in dropdown selections
    const handleChange = (selectedOption: any, key: string) => {
        setSelectedFilters({ [key]: selectedOption['value'] })
        errField['appType'] = '';
    }

    const downloadBulkUploadLeadLog = (logId: number) => {
        const downloadFn = type === "uploadID" ? downloadBulkUploadLogs: downloadBulkUploadLeadLogs;

        downloadFn({logId}).then((data: any) => {
            // setBulkLog(data?.data)
            if(data.status===STATUS_SUCCESS){

                let link = document.createElement("a");
                let urlName = data.data?.split('?')?.[0];
                urlName = urlName?.split('/');
                
                link.download = urlName?.[urlName.length-1];
                
                link.href = data.data;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                // delete link;
            }
        });
    }

    useEffect(()=>{
        const match = insuranceState.sampleCsv.find((insurance: any) => insurance.slug === type);
            
        if (match) {
            setUrlLink(match.path);
        }// eslint-disable-next-line
    }, [insuranceState.sampleCsv])

    return (

        <>
            <div className="bulk-upload-sec">
                <div className="calculator-form csv-table">
                    <FullPageLoader show={loading} />
                    <div className="row">
                        {   
                            type !== "uploadID" && 
                            <div className="col-md-12">
                                <ReactSelect
                                    options={methodList?.filter((option: any) => option.value === APP_AGENCY) || []}
                                    value={methodList?.find((option: any) => option.value === APP_AGENCY) || null}
                                    handleChange={(e: any, fieldKey: any) => handleChange(e, fieldKey)}
                                    placeholder="Application Type*"
                                    fieldKey="application_type"
                                    errorField={errField['appType'] || ""}
                                />
                            </div>
                        }
                        
                        <div className="col-md-12">
                            <h3>{translations.RuleEngineAgency?.['Upload File']}</h3>
                                <CSVImport setCsvValue={setCsvValue} csvReset={csvReset} emptyErr={emptyErr} BlankFlage={BlankFlage} setError={setEmptyErr} fileType={['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'text/csv', 'application/excel', 'application/x-excel', 'application/x-msexcel']} />
                            <div>
                            </div>
                            <div className="download-txt">
                                {translations.RuleEngineAgency?.['Download input format']} < a href={`${urlLink}`} download>{translations.RuleEngineAgency?.['Click Here']}</a>
                            </div>
                        </div>
                        {
                            HELPER.isUserHasAccessPage({ permissionID: ROLE_FEATURES['bulk_upload_application'], accessType: 'edit' }) &&
                            <div className="col-md-12">
                                <button className="btn-primary" onClick={handleImport}>{translations.commonMsg?.['Submit']} </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <div className="bulk-history-sec">
                <h3>{translations.RuleEngineAgency?.['Upload History']}</h3>
                <div className="bulk-history-table">
                    <div className="data-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>{translations.RuleEngineAgency?.['Date']} &amp; {translations.RuleEngineAgency?.['Time']}</th>
                                    <th>{translations.RuleEngineAgency?.['Who']}</th>
                                    <th>{translations.RuleEngineAgency?.['Records']}</th>
                                    <th>{translations.RuleEngineAgency?.['Status']}</th>
                                    <th>{translations.RuleEngineAgency?.['Action']}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    bulkLog?.length>0 ?
                                    bulkLog?.map(( log:any, key:number)=>
                                    <tr key={key}>
                                        <td> {log.created_at }</td>
                                        <td><span className="truncate">{log.name}</span></td>
                                        <td>
                                            <ul className="record-list-data">
                                                <li title='Success Count'>{log.successCount || 0}</li>
                                                <li><p title='Error Count'>{log.errorCount || 0}</p></li>
                                                <li title='Total Count'>{log.total_count || 0}</li>
                                            </ul>
                                        </td>
                                            <td>
                                                <span className="truncate">
                                                    {( ((+log.successCount + +log.errorCount) === +log.total_count) || (type === 'uploadID' && log.status === 1) ) ? "Completed" : "In Progress"}
                                                </span>
                                            </td>
                                        <td>
                                            <ul className="action-btn">
                                                <li onClick={()=>downloadBulkUploadLeadLog(log.id)}><i className="ic-save_alt"></i></li>
                                            </ul>
                                        </td>
                                    </tr>)
                                    :
                                    <tr><td className='t-center' colSpan={5}>{translations.RuleEngineAgency?.['No Logs Found']}</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>

    )
}
export default BulkImportModal;